import classNames from 'classnames';
import { Children, cloneElement } from 'react';

import useStyles from './styles';
import { IStaticButtonToggle } from './types';

function StaticButtonToggle({ className, children, value, onItemClick }: IStaticButtonToggle) {
  const len = children.length;
  const step = 100 / len;
  const currentIndex = children.findIndex(({ props }) => value === props.value);

  const classes = useStyles({
    selectedPosition: currentIndex * step,
    selectedWidth: 100 / len,
  });

  return (
    <div className={classNames(classes.outer, className)}>
      <div className={classes.root}>
        {Children.map(children, (child) =>
          cloneElement(child, {
            onSelect: (v: string) => onItemClick(v),
          }),
        )}
        <span className={classes.selected}></span>
      </div>
    </div>
  );
}

export default StaticButtonToggle;
